import { Box } from "@mui/material";
import BottomNav from "../components/BottomNav";

export default function Layout({ children }) {
  return (
    <Box sx={{ pb: "calc(56px + env(safe-area-inset-bottom, 0px))" }}>
      {children}

      {/* Global Bottom Navigation */}
      <BottomNav />
    </Box>
  );
}
